"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./styles/skeleton-graph.scss");
/**
 * Graph skeleton mimicking React Flow structure
 */
var SkeletonGraph = function (_a) {
    var _b = _a.height, height = _b === void 0 ? '600px' : _b, className = _a.className;
    return (react_1.default.createElement("div", { className: "skeleton-graph " + (className || ''), style: { height: height } },
        react_1.default.createElement("div", { className: "skeleton-graph-content" },
            react_1.default.createElement("div", { className: "skeleton-graph-column" },
                react_1.default.createElement("div", { className: "skeleton-graph-node" },
                    react_1.default.createElement(office_ui_fabric_react_1.Shimmer, { width: "150px" })),
                react_1.default.createElement("div", { className: "skeleton-graph-node" },
                    react_1.default.createElement(office_ui_fabric_react_1.Shimmer, { width: "150px" })),
                react_1.default.createElement("div", { className: "skeleton-graph-node" },
                    react_1.default.createElement(office_ui_fabric_react_1.Shimmer, { width: "150px" }))),
            react_1.default.createElement("div", { className: "skeleton-graph-column" },
                react_1.default.createElement("div", { className: "skeleton-graph-node" },
                    react_1.default.createElement(office_ui_fabric_react_1.Shimmer, { width: "150px" })),
                react_1.default.createElement("div", { className: "skeleton-graph-node" },
                    react_1.default.createElement(office_ui_fabric_react_1.Shimmer, { width: "150px" }))),
            react_1.default.createElement("div", { className: "skeleton-graph-column" },
                react_1.default.createElement("div", { className: "skeleton-graph-node" },
                    react_1.default.createElement(office_ui_fabric_react_1.Shimmer, { width: "150px" })),
                react_1.default.createElement("div", { className: "skeleton-graph-node" },
                    react_1.default.createElement(office_ui_fabric_react_1.Shimmer, { width: "150px" })),
                react_1.default.createElement("div", { className: "skeleton-graph-node" },
                    react_1.default.createElement(office_ui_fabric_react_1.Shimmer, { width: "150px" }))))));
};
exports.default = SkeletonGraph;
